import {useTranslation} from '@lib/intl/useTranslations'
import {equalString} from '@util/strings'
import {useCallback, useMemo} from 'react'
import {useRouter} from 'next/router'
import {editUserLocale} from '@api/user/account/editUserLocale'
import {setCookie} from '@util/cookie'

const useLanguageChange = () => {
    const t = useTranslation()
    const router = useRouter()

    const options = useMemo(() => {
        return [
            {
                id: 'ko',
                title: t('globalNavigation.language.menu.ko'),
                onClick: async () => {
                    setCookie('language', 'ko')
                    await editUserLocale('ko')
                    await router.push(router.asPath, router.asPath, {locale: 'ko'})
                },
            },
            {
                id: 'en',
                title: t('globalNavigation.language.menu.en'),
                onClick: async () => {
                    setCookie('language', 'en')
                    await editUserLocale('en')
                    await router.push(router.asPath, router.asPath, {locale: 'en'})
                },
            },
        ]
    }, [router])

    const getCurrentLanguage = useCallback(
        () => options.find(item => equalString(item?.id, router?.locale)),
        [options, router?.locale],
    )

    return {options, getCurrentLanguage}
}

export default useLanguageChange
